// PaymentSuccess.jsx
import React from "react";
import "./payment.scss";
import { Button, Layout } from "antd";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Footer } = Layout;

const PaymentSuccess = () => {
  return (<>
    <div className="payment-success-page">
      <div className="success-box">
        <div className="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M7.42857 19.5714L13.1429 23.8571L23.1429 12.4286M33.8571 1H6.71429C5.19877 1 3.74531 1.60204 2.67369 2.67369C1.60204 3.74531 1 5.19877 1 6.71429V38.1429L8.14286 33.8571L15.2857 38.1429L22.4286 33.8571L29.5714 38.1429V5.28571C29.5714 4.14909 30.0229 3.05897 30.8266 2.25526C31.6303 1.45153 32.7206 1 33.8571 1ZM33.8571 1C34.9937 1 36.084 1.45153 36.8877 2.25526C37.6914 3.05897 38.1429 4.14909 38.1429 5.28571V15.2857H29.5714" stroke="#AA1A5F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        </div>
        <h2>Purchase successful!</h2>
        <p>Your payment has been successfully processed.</p>
        <strong>Thank you for your purchase!</strong>
        {/* <Button type="primary" className="back-button">
          ← Go back to payment information
        </Button> */}
      </div>

    </div>
      <Footer>
        <FooterComponent />
      </Footer></>
  );
};

export default PaymentSuccess;
